import CallControlIndex from './Index.vue';

export default {
  routes: [
    {
      path: 'call-control',
      name: 'call_control_index',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: CallControlIndex,
    },
  ],
};
